// Les fonctions uiles
import axios from "../backend/vue-axios/axios";

const headers = {
    headers: {'Authorization': 'Bearer ' + localStorage.token}
}

export default {
    // The install method will be called with the Vue constructor as
    // the first argument, along with possible options
    install(Vue) {
        Vue.prototype.$searchUser = (str) => {
            return new Promise((resolve, reject) => {
                axios.get('/admin/users/search?req=' + str, {headers: {'Authorization': 'Bearer ' + localStorage.token}})
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }

        Vue.prototype.$adminGetUser = (id) => {
            return new Promise((resolve, reject) => {
                axios.get('/admin/users/' + id, {headers: {'Authorization': 'Bearer ' + localStorage.token}})
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }

        Vue.prototype.$adminGetFamily = (id) => {
            return new Promise((resolve, reject) => {
                axios.get('/admin/families/' + id, {headers: {'Authorization': 'Bearer ' + localStorage.token}})
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }

        /**
         *
         * Modifie un model existant
         *
         * @param model {String}
         * @param fields {Object}
         * @param id {Number}
         * @returns {Promise<unknown>}
         */

        Vue.prototype.$adminUpdateModel = (model, fields, id) => {
            return new Promise((resolve, reject) => {
                axios.put('/' + model + '/' + id, fields, headers)
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        };

        Vue.prototype.$adminCreatePayments = (family_id, type, period, discount) => {
            return new Promise((resolve, reject) => {
                axios.get('/admin/families/' + family_id + '/create-payment?period=' + period + '&type=' + type + '&discount=' + discount, {headers: {'Authorization': 'Bearer ' + localStorage.token}})
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                    })
            })
        }

        Vue.prototype.$adminReceptPayments = (family_id) => {
            return new Promise((resolve, reject) => {
                axios.get('/admin/families/' + family_id + '/payment-received', {headers: {'Authorization': 'Bearer ' + localStorage.token}})
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                    })
            })
        }

        Vue.prototype.$adminDestroyPayments = (family_id) => {
            return new Promise((resolve, reject) => {
                axios.get('/admin/families/' + family_id + '/destroy-payments', {headers: {'Authorization': 'Bearer ' + localStorage.token}})
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                    })
            })
        }

        Vue.prototype.$adminChangePaymentStatus = (id, status) => {
            return new Promise((resolve, reject) => {
                axios.put('/admin/payments/' + id, {status}, {headers: {'Authorization': 'Bearer ' + localStorage.token}})
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                    })
            })
        }

        Vue.prototype.$adminGetFamilies = () => {
            return new Promise((resolve, reject) => {
                axios.get('/admin/families', {headers: {'Authorization': 'Bearer ' + localStorage.token}})
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                    })
            })
        }

        Vue.prototype.$displayRole = (role) => {
            switch (role) {

                case 'admin': {
                    return "Administrateur"
                }
                case 'dev': {
                    return "Développeur"
                }
                case "payment": {
                    return "Éditeur"
                }
                case "prof": {
                    return "Professeur"
                }
                case "consult": {
                    return "Lecteur"
                }
            }
        }
    }
}
